const STORAGE_KEY = 'ttn-cultural-warning-agreed';
const AGREED_VALUE = 'true';

export function hasAgreed() {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === AGREED_VALUE;
    } catch (e) {
        // Safari private browsing and hardened privacy settings throw on access.
        // Failing closed means the warning shows again, which is the safe default.
        return false;
    }
}

export function setAgreed() {
    try {
        sessionStorage.setItem(STORAGE_KEY, AGREED_VALUE);
    } catch (e) {
        // Non-fatal: the warning will simply be shown again this visit.
    }
}
